import { useQuery } from '@tanstack/react-query';

import { threadService } from '@/services/thread.service';

export const useGetAllThreads = (pageNumber: number) => {
	const { data, isLoading, isError, error, refetch, isPending } = useQuery({
		queryKey: ['thread', pageNumber],
		queryFn: () => threadService.getAllThreads(pageNumber),
	});
	return {
		threads: data?.data ?? [],
		totalPages: data?.pageCount,
		isLoading,
		isError,
		error,
		refetch,
		isPending,
	};
};
